(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_algolia-trending-search"] && !Shopify.designMode) return;
  try {
    // ⚠ Auto-generated from src/blocks/_algolia-trending-search/_algolia-trending-search.ts — do not edit directly.
// src/blocks/_algolia-trending-search/_algolia-trending-search.ts
"use strict";
(() => {
  var __typeError = (msg) => {
    throw TypeError(msg);
  };
  var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
  var __privateGet = (obj, member, getter) => (__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
  var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
  var __privateSet = (obj, member, value, setter) => (__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
  var __privateMethod = (obj, member, method) => (__accessCheck(obj, member, "access private method"), method);

  // src/shared/algolia/constants.ts
  var CDN_ALGOLIASEARCH = "https://cdn.jsdelivr.net/npm/algoliasearch@5.56.0/dist/lite/builds/browser.umd.js";
  var SRI_ALGOLIASEARCH = "sha384-jydndPKly6IFOH8FPmOV3qHV/YxfBbkZBbaNHhojUEnFzJpw458cQC2x80yc6cdb";

  // src/shared/algolia/dom.ts
  function escapeHtml(value) {
    return String(value ?? "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#39;");
  }

  // src/shared/algolia/load-script.ts
  var pending = /* @__PURE__ */ new Map();
  function loadScript(src, integrity) {
    const cached = pending.get(src);
    if (cached) return cached;
    const promise = new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.src = src;
      script.crossOrigin = "anonymous";
      if (integrity) script.integrity = integrity;
      script.onload = () => resolve();
      script.onerror = () => reject(new Error(`Failed to load script: ${src}`));
      document.head.appendChild(script);
    });
    pending.set(src, promise);
    return promise;
  }

  // src/shared/algolia/urls.ts
  function shopifyRoot() {
    return window.Shopify?.routes?.root ?? "/";
  }
  function searchUrlFor(query) {
    const root = shopifyRoot();
    const normalizedRoot = root.endsWith("/") ? root : `${root}/`;
    return `${normalizedRoot}search?q=${encodeURIComponent(query)}`;
  }

  // src/blocks/_algolia-trending-search/_algolia-trending-search.ts
  var _fetched, _observer, _AlgoliaTrending_instances, disconnect_fn, config_fn, run_fn, fetchSuggestions_fn, render_fn;
  var AlgoliaTrending = class extends HTMLElement {
    constructor() {
      super(...arguments);
      __privateAdd(this, _AlgoliaTrending_instances);
      __privateAdd(this, _fetched, false);
      __privateAdd(this, _observer, null);
    }
    connectedCallback() {
      const dialog = this.closest("dialog");
      if (!dialog || !__privateMethod(this, _AlgoliaTrending_instances, config_fn).call(this)) {
        this.hidden = true;
        return;
      }
      if (dialog.open) {
        void __privateMethod(this, _AlgoliaTrending_instances, run_fn).call(this);
        return;
      }
      __privateSet(this, _observer, new MutationObserver(() => {
        if (dialog.open) void __privateMethod(this, _AlgoliaTrending_instances, run_fn).call(this);
      }));
      __privateGet(this, _observer).observe(dialog, { attributeFilter: ["open"] });
    }
    disconnectedCallback() {
      __privateMethod(this, _AlgoliaTrending_instances, disconnect_fn).call(this);
    }
  };
  _fetched = new WeakMap();
  _observer = new WeakMap();
  _AlgoliaTrending_instances = new WeakSet();
  disconnect_fn = function() {
    __privateGet(this, _observer)?.disconnect();
    __privateSet(this, _observer, null);
  };
  /** Les réglages voyagent en data-attributes sur la coquille de la section. */
  config_fn = function() {
    const searchEl = this.closest("c-algolia-header-search");
    if (!searchEl) return null;
    const { algoliaAppId, algoliaApiKey, algoliaIndexSuggestions } = searchEl.dataset;
    if (!algoliaAppId || !algoliaApiKey || !algoliaIndexSuggestions) return null;
    return {
      apiKey: algoliaApiKey,
      appId: algoliaAppId,
      indexName: algoliaIndexSuggestions
    };
  };
  run_fn = async function() {
    if (__privateGet(this, _fetched)) return;
    __privateSet(this, _fetched, true);
    __privateMethod(this, _AlgoliaTrending_instances, disconnect_fn).call(this);
    const config = __privateMethod(this, _AlgoliaTrending_instances, config_fn).call(this);
    if (!config) {
      this.hidden = true;
      return;
    }
    const algoliaWindow = window;
    if (!algoliaWindow["algoliasearch/lite"]) {
      await loadScript(CDN_ALGOLIASEARCH, SRI_ALGOLIASEARCH);
    }
    const lite = algoliaWindow["algoliasearch/lite"];
    if (!lite) {
      this.hidden = true;
      return;
    }
    const client = lite.liteClient(config.appId, config.apiKey);
    const limit = Math.min(parseInt(this.dataset.limit ?? "", 10) || 4, 4);
    try {
      await __privateMethod(this, _AlgoliaTrending_instances, fetchSuggestions_fn).call(this, client, config.indexName, limit);
    } catch (error) {
      this.hidden = true;
      console.warn("[algolia-trending] suggestions request failed", error);
    }
  };
  fetchSuggestions_fn = async function(client, indexName, limit) {
    const { results } = await client.search([
      {
        indexName,
        params: {
          query: "",
          // Empty query → returns the most searched terms.
          hitsPerPage: limit,
          // Les seuls attributs que `#render` lit. Sans ce tri, chaque
          // enregistrement ramène l'objet imbriqué de son index source
          // (`exact_nb_hits`, `facets`) : réponse deux fois plus lourde pour
          // rien.
          attributesToRetrieve: ["query", "objectID", "title"],
          attributesToHighlight: [],
          // Une requête vide n'est pas une recherche de l'internaute : elle n'a
          // rien à dire aux analytics Algolia. Les surfaces InstantSearch
          // neutralisent la même chose via `withoutEmptyQueryAnalytics`
          // (src/shared/algolia-page/search-client.ts) ; ici le paramètre est
          // écrit en clair — ce bloc ne construit qu'une requête, et importer le
          // wrapper l'inlinerait dans l'IIFE pour un seul booléen.
          analytics: false
          // Ni `filters` ni `ruleContexts` : un index de query-suggestions n'a
          // pas d'`attributesForFaceting` et ne porte aucune query rule, donc le
          // garde-fou « produits masqués » n'y a rien à filtrer. L'API les
          // acceptait sans broncher (HTTP 200, vérifié) — ils ne faisaient rien.
        }
      }
    ]);
    __privateMethod(this, _AlgoliaTrending_instances, render_fn).call(this, results[0]?.hits ?? []);
  };
  render_fn = function(hits) {
    const list = this.querySelector("[data-suggestions]");
    if (!list) return;
    const labels = hits.map((hit) => hit.query ?? hit.title ?? hit.objectID ?? "").filter((label) => label !== "");
    if (!labels.length) {
      this.hidden = true;
      return;
    }
    this.hidden = false;
    list.innerHTML = labels.map(
      (label) => `<li><a href='${escapeHtml(searchUrlFor(label))}' class='label-m-light'>${escapeHtml(label)}</a></li>`
    ).join("");
  };
  if (!customElements.get("algolia-trending")) {
    customElements.define("algolia-trending", AlgoliaTrending);
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_banner_content"] && !Shopify.designMode) return;
  try {
    // ⚠ Auto-generated from src/blocks/_banner_content/_banner_content.ts — do not edit directly.
// src/blocks/_banner_content/_banner_content.ts
"use strict";
(() => {
  // src/blocks/_banner_content/_banner_content.ts
  var TCountdown = class extends HTMLElement {
    constructor() {
      super(...arguments);
      this.targetDate = null;
      this.intervalId = null;
      this.daysElement = null;
      this.hoursElement = null;
      this.minutesElement = null;
      this.secondsElement = null;
      this.containerElement = null;
    }
    static get observedAttributes() {
      return ["target-date"];
    }
    connectedCallback() {
      this.cacheElements();
      this.syncTargetDateFromAttribute();
      this.startCountdown();
    }
    disconnectedCallback() {
      this.stopCountdown();
    }
    attributeChangedCallback(name, oldValue, newValue) {
      if (name !== "target-date" || newValue === oldValue) {
        return;
      }
      this.syncTargetDateFromAttribute();
      this.startCountdown();
    }
    cacheElements() {
      this.daysElement = this.querySelector(".days");
      this.hoursElement = this.querySelector(".hours");
      this.minutesElement = this.querySelector(".minutes");
      this.secondsElement = this.querySelector(".seconds");
      this.containerElement = this.querySelector(
        ".countdown-container"
      );
    }
    syncTargetDateFromAttribute() {
      const rawTargetDate = this.getAttribute("target-date");
      if (!rawTargetDate) {
        this.targetDate = null;
        return;
      }
      const parsedDate = new Date(rawTargetDate).getTime();
      this.targetDate = Number.isFinite(parsedDate) ? parsedDate : null;
    }
    startCountdown() {
      this.stopCountdown();
      if (!this.hasRequiredElements() || this.targetDate === null) {
        return;
      }
      this.updateCountdown();
      this.intervalId = window.setInterval(() => {
        this.updateCountdown();
      }, 1e3);
    }
    stopCountdown() {
      if (this.intervalId === null) {
        return;
      }
      window.clearInterval(this.intervalId);
      this.intervalId = null;
    }
    hasRequiredElements() {
      return Boolean(
        this.daysElement && this.hoursElement && this.minutesElement && this.secondsElement && this.containerElement
      );
    }
    padNumber(value) {
      return value.toString().padStart(2, "0");
    }
    setExpiredState() {
      this.stopCountdown();
      if (!this.containerElement) {
        return;
      }
      const expiredMessage = this.dataset.expiredMessage ?? "";
      this.containerElement.innerHTML = "";
      const expiredNode = document.createElement("div");
      expiredNode.className = "expired";
      expiredNode.textContent = expiredMessage;
      this.containerElement.append(expiredNode);
    }
    updateCountdown() {
      if (!this.hasRequiredElements() || this.targetDate === null) {
        return;
      }
      const now = Date.now();
      const distance = this.targetDate - now;
      if (distance < 0) {
        this.setExpiredState();
        return;
      }
      const days = Math.floor(distance / (1e3 * 60 * 60 * 24));
      const hours = Math.floor(
        distance % (1e3 * 60 * 60 * 24) / (1e3 * 60 * 60)
      );
      const minutes = Math.floor(distance % (1e3 * 60 * 60) / (1e3 * 60));
      const seconds = Math.floor(distance % (1e3 * 60) / 1e3);
      if (this.daysElement && this.hoursElement && this.minutesElement && this.secondsElement) {
        this.daysElement.textContent = this.padNumber(days);
        this.hoursElement.textContent = this.padNumber(hours);
        this.minutesElement.textContent = this.padNumber(minutes);
        this.secondsElement.textContent = this.padNumber(seconds);
      }
    }
  };
  var BannerContent = class extends HTMLElement {
    constructor() {
      super(...arguments);
      this.bannerClose = null;
      this.bannerId = null;
    }
    connectedCallback() {
      this.bannerClose = this.querySelector(".banner__close");
      this.bannerId = this.getAttribute("data-id");
      this.bannerClose?.addEventListener("click", () => {
        this.closeBanner();
      });
    }
    disconnectedCallback() {
      this.bannerClose?.removeEventListener("click", () => {
        this.closeBanner();
      });
    }
    closeBanner() {
      this.parentElement?.classList.add("is-hide");
      this.parentElement?.remove();
      sessionStorage.setItem(
        `bannerContent-${this.bannerId}`,
        this.bannerId ?? ""
      );
    }
  };
  if (!window.customElements.get("t-countdown")) {
    window.customElements.define("t-countdown", TCountdown);
  }
  if (!window.customElements.get("c-banner-content")) {
    window.customElements.define("c-banner-content", BannerContent);
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_classic-recommend-list"] && !Shopify.designMode) return;
  try {
    // ⚠ Auto-generated from src/blocks/_classic-recommend-list/_classic-recommend-list.ts — do not edit directly.
// src/blocks/_classic-recommend-list/_classic-recommend-list.ts
"use strict";
(() => {
  // src/shared/card-product/align-product-card-zones.ts
  var CARD_SELECTOR = ".card-product:not(.set-to-compose)";
  var ZONE_CONFIGS = [
    { selector: ".card-product__meta", cssVar: "--card-meta-min-height" },
    { selector: ".card-product__price", cssVar: "--card-price-min-height" }
  ];
  function groupIndicesByRow(tops) {
    const rows = [];
    for (const [index, top] of tops.entries()) {
      const row = rows.find((group) => {
        const first = group[0];
        return first !== void 0 && Math.abs((tops[first] ?? 0) - top) <= 1;
      });
      if (row) {
        row.push(index);
      } else {
        rows.push([index]);
      }
    }
    return rows;
  }
  function alignProductCardZones(root) {
    const cards = Array.from(root.querySelectorAll(CARD_SELECTOR));
    if (cards.length === 0) return;
    const zones = ZONE_CONFIGS.map(
      ({ selector }) => cards.map((card) => card.querySelector(selector))
    );
    for (const [zoneIndex, elements] of zones.entries()) {
      const cssVar = ZONE_CONFIGS[zoneIndex]?.cssVar;
      if (cssVar === void 0) continue;
      for (const el of elements) {
        el?.style.setProperty(cssVar, "0px");
      }
    }
    const tops = cards.map((card) => card.offsetTop);
    const heights = zones.map(
      (elements) => elements.map((el) => el?.scrollHeight ?? 0)
    );
    const rows = groupIndicesByRow(tops);
    for (const [zoneIndex, elements] of zones.entries()) {
      const cssVar = ZONE_CONFIGS[zoneIndex]?.cssVar;
      const zoneHeights = heights[zoneIndex];
      if (cssVar === void 0 || zoneHeights === void 0) continue;
      for (const row of rows) {
        let maxHeight = 0;
        for (const index of row) {
          maxHeight = Math.max(maxHeight, zoneHeights[index] ?? 0);
        }
        const value = `${String(maxHeight)}px`;
        for (const index of row) {
          elements[index]?.style.setProperty(cssVar, value);
        }
      }
    }
  }

  // src/shared/card-product/predecode-hover-visuals.ts
  var HOVER_IMAGE_SELECTOR = ".card-product_image.is-hover-active figure:nth-child(even) img";
  var NEAR_VIEWPORT_MARGIN = "400px";
  var seen = /* @__PURE__ */ new WeakSet();
  var observer = null;
  function whenIdle(task) {
    if (typeof requestIdleCallback === "function") {
      requestIdleCallback(task, { timeout: 2e3 });
      return;
    }
    window.setTimeout(task, 200);
  }
  function decodeWhenLoaded(image) {
    const decode = () => whenIdle(() => void image.decode().catch(() => {
    }));
    if (image.complete && image.naturalWidth > 0) {
      decode();
      return;
    }
    image.addEventListener("load", decode, { once: true });
  }
  function nearViewportObserver() {
    if (observer) return observer;
    if (typeof IntersectionObserver !== "function") return null;
    observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          observer?.unobserve(entry.target);
          decodeWhenLoaded(entry.target);
        }
      },
      { rootMargin: NEAR_VIEWPORT_MARGIN }
    );
    return observer;
  }
  function predecodeHoverVisuals(root) {
    const images = root.querySelectorAll(HOVER_IMAGE_SELECTOR);
    if (images.length === 0) return;
    const io = nearViewportObserver();
    for (const image of images) {
      if (seen.has(image)) continue;
      seen.add(image);
      if (!io) {
        decodeWhenLoaded(image);
        continue;
      }
      io.observe(image);
    }
  }

  // src/shared/gallery_list/gallery_list.ts
  var GalleryListBase = class extends HTMLElement {
    constructor() {
      super(...arguments);
      this.embla = null;
      this.sliderToScrollMobile = "auto";
      this.sliderToScrollDesktop = "auto";
      this.parentContainer = null;
      this.viewport = null;
      this.container = null;
      this.prevButton = null;
      this.nextButton = null;
      this.progressNode = null;
      this.prevContainer = null;
      this.nextContainer = null;
      this.firstSlideObserver = null;
      this.zoneAlignObserver = null;
      this.isAligningZones = false;
      /** Dernière largeur alignée, pour ignorer les resizes en hauteur. */
      this.lastAlignedWidth = 0;
      this.onPrevClick = () => this.embla?.scrollPrev();
      this.onNextClick = () => this.embla?.scrollNext();
      this.onPrevMouseMove = (e) => this.followMouse(e, this.prevButton);
      this.onNextMouseMove = (e) => this.followMouse(e, this.nextButton);
      this.onPrevMouseLeave = () => this.resetButton(this.prevButton);
      this.onNextMouseLeave = () => this.resetButton(this.nextButton);
      /**
       * Re-equalizes card text zones; skips while a sync is already in flight.
       *
       * Ne touche PAS au `ResizeObserver` : le déconnecter ici puis le ré-`observe()`
       * en sortie relançait l'alignement à chaque frame, sans fin — `observe()` remet
       * `lastReportedSize` à zéro, donc la notification suivante était garantie. Voir
       * la garde en largeur de `bindZoneAlignment`.
       */
      this.alignZones = () => {
        if (!this.container || this.isAligningZones) return;
        this.isAligningZones = true;
        try {
          alignProductCardZones(this.container);
          predecodeHoverVisuals(this.container);
        } finally {
          this.isAligningZones = false;
        }
      };
    }
    followMouse(e, button) {
      if (!button) return;
      const container = e.currentTarget;
      const rect = container.getBoundingClientRect();
      const offsetX = e.clientX - rect.left - rect.width / 2;
      const offsetY = e.clientY - rect.top - rect.height / 2;
      button.style.transform = `translate(${offsetX}px, ${offsetY}px)`;
    }
    resetButton(button) {
      if (!button) return;
      button.style.transform = "";
    }
    // Hook for subclasses to react to scroll events
    onScroll() {
    }
    connectedCallback() {
      this.parentContainer = this.closest("c-gallery-container");
      this.viewport = this.querySelector(".embla__viewport");
      this.container = this.querySelector(".embla__container");
      this.prevButton = this.querySelector(".embla__prev");
      this.nextButton = this.querySelector(".embla__next");
      this.progressNode = this.querySelector(".embla__progress__bar");
      this.prevContainer = this.querySelector(".container_embla__prev");
      this.nextContainer = this.querySelector(".container_embla__next");
      this.sliderToScrollMobile = this.dataset.slidesToScrollMobile || "auto";
      this.sliderToScrollDesktop = this.dataset.slidesToScrollDesktop || "auto";
      if (this.parentContainer?.classList.contains("v-slider")) {
        this.initEmbla();
        this.bindProgress();
        this.bindMouseFollow();
      }
      this.classList.remove("shimmer");
      this.bindFirstSlideAnimation();
      this.bindZoneAlignment();
    }
    /**
     * Keeps meta / price aligned across cards in a row.
     * Runs on connect, Embla reinit/resize, and container width changes. Does not
     * call embla.reInit() to avoid AutoHeight loops.
     *
     * Garde en LARGEUR : l'alignement ne dépend que de la largeur disponible et ne
     * produit que des changements de HAUTEUR. Réagir à la hauteur revenait à
     * réagir à son propre effet. Le chargement des polices, que l'observation
     * rattrapait par accident, est accroché explicitement plus bas.
     */
    bindZoneAlignment() {
      const container = this.container;
      if (!container) return;
      this.alignZones();
      this.zoneAlignObserver = new ResizeObserver((entries) => {
        const width = Math.round(entries[0]?.contentRect.width ?? 0);
        if (width === 0 || width === this.lastAlignedWidth) return;
        this.lastAlignedWidth = width;
        this.alignZones();
      });
      this.lastAlignedWidth = Math.round(container.getBoundingClientRect().width);
      this.zoneAlignObserver.observe(container);
      void document.fonts.ready.then(() => this.alignZones());
      this.embla?.on("reinit", () => this.alignZones()).on("resize", () => this.alignZones());
    }
    bindFirstSlideAnimation() {
      const firstSlide = this.querySelector(
        ".embla__slide:first-child"
      );
      if (!firstSlide) return;
      this.firstSlideObserver = new IntersectionObserver(
        (entries) => {
          const entry = entries[0];
          if (!entry.isIntersecting) return;
          this.firstSlideObserver?.disconnect();
          this.firstSlideObserver = null;
          const quickBuyContainer = firstSlide.querySelector(
            ".card-product-quick-buy__container"
          );
          if (!quickBuyContainer) return;
          quickBuyContainer.classList.add("is-animate-quick-buy");
          setTimeout(
            () => quickBuyContainer.classList.remove("is-animate-quick-buy"),
            1400
          );
        },
        { threshold: 0.8 }
      );
      this.firstSlideObserver.observe(firstSlide);
    }
    bindMouseFollow() {
      this.prevContainer?.addEventListener("mousemove", this.onPrevMouseMove);
      this.prevContainer?.addEventListener("mouseleave", this.onPrevMouseLeave);
      this.nextContainer?.addEventListener("mousemove", this.onNextMouseMove);
      this.nextContainer?.addEventListener("mouseleave", this.onNextMouseLeave);
    }
    initEmbla() {
      if (!this.viewport || !this.container) return;
      this.embla = EmblaCarousel(
        this.viewport,
        {
          dragFree: false,
          active: true,
          slidesToScroll: this.sliderToScrollMobile,
          "(min-width: 1024px)": {
            active: false,
            dragFree: true,
            slidesToScroll: this.sliderToScrollDesktop
          }
        },
        [EmblaCarouselAutoHeight()]
      );
      this.prevButton?.addEventListener("click", this.onPrevClick);
      this.nextButton?.addEventListener("click", this.onNextClick);
    }
    bindProgress() {
      if (!this.embla || !this.progressNode) return;
      const progressNode = this.progressNode;
      const applyProgress = () => {
        if (!this.embla) return;
        const snapCount = this.embla.scrollSnapList().length;
        const selected = this.embla.selectedScrollSnap();
        progressNode.style.width = `${100 / snapCount}%`;
        progressNode.style.transform = `translate3d(${selected * 100}%,0px,0px)`;
        this.prevButton?.parentElement?.toggleAttribute(
          "data-disabled",
          !this.embla.canScrollPrev()
        );
        this.nextButton?.parentElement?.toggleAttribute(
          "data-disabled",
          !this.embla.canScrollNext()
        );
        this.onScroll();
      };
      applyProgress();
      this.embla.on("reinit", () => applyProgress()).on("resize", () => applyProgress()).on("scroll", () => applyProgress()).on("slidefocus", () => applyProgress());
    }
    disconnectedCallback() {
      this.zoneAlignObserver?.disconnect();
      this.zoneAlignObserver = null;
      this.lastAlignedWidth = 0;
      this.embla?.destroy();
      this.embla = null;
      this.firstSlideObserver?.disconnect();
      this.firstSlideObserver = null;
      this.prevButton?.removeEventListener("click", this.onPrevClick);
      this.nextButton?.removeEventListener("click", this.onNextClick);
      this.prevContainer?.removeEventListener("mousemove", this.onPrevMouseMove);
      this.prevContainer?.removeEventListener("mouseleave", this.onPrevMouseLeave);
      this.nextContainer?.removeEventListener("mousemove", this.onNextMouseMove);
      this.nextContainer?.removeEventListener("mouseleave", this.onNextMouseLeave);
    }
  };

  // src/blocks/_classic-recommend-list/_classic-recommend-list.ts
  var ClassicRecommendList = class extends GalleryListBase {
    constructor() {
      super(...arguments);
      this.abortController = null;
      this.isSliderReady = false;
    }
    connectedCallback() {
      this.abortController?.abort();
      this.abortController = new AbortController();
      this.loadRecommendations();
    }
    disconnectedCallback() {
      this.abortController?.abort();
      this.abortController = null;
      super.disconnectedCallback();
    }
    async loadRecommendations() {
      const urls = this.recommendationUrls();
      if (urls.length === 0) {
        this.setEmptyState();
        return;
      }
      try {
        const responses = await Promise.all(
          urls.map(
            (url) => fetch(url, { signal: this.abortController?.signal }).then(
              (response) => {
                if (!response.ok) {
                  throw new Error(
                    `Classic recommendations failed: ${response.status}`
                  );
                }
                return response.text();
              }
            )
          )
        );
        const slides = responses.flatMap(
          (text) => this.extractSlidesFromSectionResponse(text)
        );
        this.renderSlides(slides);
      } catch (error) {
        if (error.name !== "AbortError") {
          console.error(error);
          this.setEmptyState();
        }
      }
    }
    recommendationUrls() {
      const type = this.dataset.recommendationType;
      const urls = [];
      if (type === "related" || type === "all") {
        if (this.dataset.relatedUrl) urls.push(this.dataset.relatedUrl);
      }
      if (type === "complementary" || type === "all") {
        if (this.dataset.complementaryUrl) {
          urls.push(this.dataset.complementaryUrl);
        }
      }
      return urls;
    }
    extractSlidesFromSectionResponse(text) {
      const html = document.createElement("div");
      html.innerHTML = text;
      return Array.from(
        html.querySelectorAll(
          `c-classic-recommend-list[data-id="${this.dataset.id}"] .embla__slide`
        )
      ).map((slide) => slide.outerHTML);
    }
    renderSlides(slides) {
      const container = this.querySelector("[data-classic-recommend-items]");
      if (!container || slides.length === 0) {
        this.setEmptyState();
        return;
      }
      container.innerHTML = slides.join("");
      this.style.setProperty("--nbr-slides", String(slides.length));
      this.toggleAttribute("data-hide-progress-bar-desktop", slides.length < 5);
      this.hidden = false;
      if (!this.isSliderReady) {
        this.isSliderReady = true;
        super.connectedCallback();
      }
    }
    setEmptyState() {
      const container = this.querySelector("[data-classic-recommend-items]");
      if (container) container.innerHTML = "";
      this.hidden = true;
    }
  };
  if (!window.customElements.get("c-classic-recommend-list")) {
    window.customElements.define("c-classic-recommend-list", ClassicRecommendList);
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_collection-card-list"] && !Shopify.designMode) return;
  try {
    // ⚠ Auto-generated from src/blocks/_collection-card-list/_collection-card-list.ts — do not edit directly.
// src/blocks/_collection-card-list/_collection-card-list.ts
"use strict";
(() => {
  // src/shared/card-product/align-product-card-zones.ts
  var CARD_SELECTOR = ".card-product:not(.set-to-compose)";
  var ZONE_CONFIGS = [
    { selector: ".card-product__meta", cssVar: "--card-meta-min-height" },
    { selector: ".card-product__price", cssVar: "--card-price-min-height" }
  ];
  function groupIndicesByRow(tops) {
    const rows = [];
    for (const [index, top] of tops.entries()) {
      const row = rows.find((group) => {
        const first = group[0];
        return first !== void 0 && Math.abs((tops[first] ?? 0) - top) <= 1;
      });
      if (row) {
        row.push(index);
      } else {
        rows.push([index]);
      }
    }
    return rows;
  }
  function alignProductCardZones(root) {
    const cards = Array.from(root.querySelectorAll(CARD_SELECTOR));
    if (cards.length === 0) return;
    const zones = ZONE_CONFIGS.map(
      ({ selector }) => cards.map((card) => card.querySelector(selector))
    );
    for (const [zoneIndex, elements] of zones.entries()) {
      const cssVar = ZONE_CONFIGS[zoneIndex]?.cssVar;
      if (cssVar === void 0) continue;
      for (const el of elements) {
        el?.style.setProperty(cssVar, "0px");
      }
    }
    const tops = cards.map((card) => card.offsetTop);
    const heights = zones.map(
      (elements) => elements.map((el) => el?.scrollHeight ?? 0)
    );
    const rows = groupIndicesByRow(tops);
    for (const [zoneIndex, elements] of zones.entries()) {
      const cssVar = ZONE_CONFIGS[zoneIndex]?.cssVar;
      const zoneHeights = heights[zoneIndex];
      if (cssVar === void 0 || zoneHeights === void 0) continue;
      for (const row of rows) {
        let maxHeight = 0;
        for (const index of row) {
          maxHeight = Math.max(maxHeight, zoneHeights[index] ?? 0);
        }
        const value = `${String(maxHeight)}px`;
        for (const index of row) {
          elements[index]?.style.setProperty(cssVar, value);
        }
      }
    }
  }

  // src/shared/card-product/predecode-hover-visuals.ts
  var HOVER_IMAGE_SELECTOR = ".card-product_image.is-hover-active figure:nth-child(even) img";
  var NEAR_VIEWPORT_MARGIN = "400px";
  var seen = /* @__PURE__ */ new WeakSet();
  var observer = null;
  function whenIdle(task) {
    if (typeof requestIdleCallback === "function") {
      requestIdleCallback(task, { timeout: 2e3 });
      return;
    }
    window.setTimeout(task, 200);
  }
  function decodeWhenLoaded(image) {
    const decode = () => whenIdle(() => void image.decode().catch(() => {
    }));
    if (image.complete && image.naturalWidth > 0) {
      decode();
      return;
    }
    image.addEventListener("load", decode, { once: true });
  }
  function nearViewportObserver() {
    if (observer) return observer;
    if (typeof IntersectionObserver !== "function") return null;
    observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          observer?.unobserve(entry.target);
          decodeWhenLoaded(entry.target);
        }
      },
      { rootMargin: NEAR_VIEWPORT_MARGIN }
    );
    return observer;
  }
  function predecodeHoverVisuals(root) {
    const images = root.querySelectorAll(HOVER_IMAGE_SELECTOR);
    if (images.length === 0) return;
    const io = nearViewportObserver();
    for (const image of images) {
      if (seen.has(image)) continue;
      seen.add(image);
      if (!io) {
        decodeWhenLoaded(image);
        continue;
      }
      io.observe(image);
    }
  }

  // src/shared/gallery_list/gallery_list.ts
  var GalleryListBase = class extends HTMLElement {
    constructor() {
      super(...arguments);
      this.embla = null;
      this.sliderToScrollMobile = "auto";
      this.sliderToScrollDesktop = "auto";
      this.parentContainer = null;
      this.viewport = null;
      this.container = null;
      this.prevButton = null;
      this.nextButton = null;
      this.progressNode = null;
      this.prevContainer = null;
      this.nextContainer = null;
      this.firstSlideObserver = null;
      this.zoneAlignObserver = null;
      this.isAligningZones = false;
      /** Dernière largeur alignée, pour ignorer les resizes en hauteur. */
      this.lastAlignedWidth = 0;
      this.onPrevClick = () => this.embla?.scrollPrev();
      this.onNextClick = () => this.embla?.scrollNext();
      this.onPrevMouseMove = (e) => this.followMouse(e, this.prevButton);
      this.onNextMouseMove = (e) => this.followMouse(e, this.nextButton);
      this.onPrevMouseLeave = () => this.resetButton(this.prevButton);
      this.onNextMouseLeave = () => this.resetButton(this.nextButton);
      /**
       * Re-equalizes card text zones; skips while a sync is already in flight.
       *
       * Ne touche PAS au `ResizeObserver` : le déconnecter ici puis le ré-`observe()`
       * en sortie relançait l'alignement à chaque frame, sans fin — `observe()` remet
       * `lastReportedSize` à zéro, donc la notification suivante était garantie. Voir
       * la garde en largeur de `bindZoneAlignment`.
       */
      this.alignZones = () => {
        if (!this.container || this.isAligningZones) return;
        this.isAligningZones = true;
        try {
          alignProductCardZones(this.container);
          predecodeHoverVisuals(this.container);
        } finally {
          this.isAligningZones = false;
        }
      };
    }
    followMouse(e, button) {
      if (!button) return;
      const container = e.currentTarget;
      const rect = container.getBoundingClientRect();
      const offsetX = e.clientX - rect.left - rect.width / 2;
      const offsetY = e.clientY - rect.top - rect.height / 2;
      button.style.transform = `translate(${offsetX}px, ${offsetY}px)`;
    }
    resetButton(button) {
      if (!button) return;
      button.style.transform = "";
    }
    // Hook for subclasses to react to scroll events
    onScroll() {
    }
    connectedCallback() {
      this.parentContainer = this.closest("c-gallery-container");
      this.viewport = this.querySelector(".embla__viewport");
      this.container = this.querySelector(".embla__container");
      this.prevButton = this.querySelector(".embla__prev");
      this.nextButton = this.querySelector(".embla__next");
      this.progressNode = this.querySelector(".embla__progress__bar");
      this.prevContainer = this.querySelector(".container_embla__prev");
      this.nextContainer = this.querySelector(".container_embla__next");
      this.sliderToScrollMobile = this.dataset.slidesToScrollMobile || "auto";
      this.sliderToScrollDesktop = this.dataset.slidesToScrollDesktop || "auto";
      if (this.parentContainer?.classList.contains("v-slider")) {
        this.initEmbla();
        this.bindProgress();
        this.bindMouseFollow();
      }
      this.classList.remove("shimmer");
      this.bindFirstSlideAnimation();
      this.bindZoneAlignment();
    }
    /**
     * Keeps meta / price aligned across cards in a row.
     * Runs on connect, Embla reinit/resize, and container width changes. Does not
     * call embla.reInit() to avoid AutoHeight loops.
     *
     * Garde en LARGEUR : l'alignement ne dépend que de la largeur disponible et ne
     * produit que des changements de HAUTEUR. Réagir à la hauteur revenait à
     * réagir à son propre effet. Le chargement des polices, que l'observation
     * rattrapait par accident, est accroché explicitement plus bas.
     */
    bindZoneAlignment() {
      const container = this.container;
      if (!container) return;
      this.alignZones();
      this.zoneAlignObserver = new ResizeObserver((entries) => {
        const width = Math.round(entries[0]?.contentRect.width ?? 0);
        if (width === 0 || width === this.lastAlignedWidth) return;
        this.lastAlignedWidth = width;
        this.alignZones();
      });
      this.lastAlignedWidth = Math.round(container.getBoundingClientRect().width);
      this.zoneAlignObserver.observe(container);
      void document.fonts.ready.then(() => this.alignZones());
      this.embla?.on("reinit", () => this.alignZones()).on("resize", () => this.alignZones());
    }
    bindFirstSlideAnimation() {
      const firstSlide = this.querySelector(
        ".embla__slide:first-child"
      );
      if (!firstSlide) return;
      this.firstSlideObserver = new IntersectionObserver(
        (entries) => {
          const entry = entries[0];
          if (!entry.isIntersecting) return;
          this.firstSlideObserver?.disconnect();
          this.firstSlideObserver = null;
          const quickBuyContainer = firstSlide.querySelector(
            ".card-product-quick-buy__container"
          );
          if (!quickBuyContainer) return;
          quickBuyContainer.classList.add("is-animate-quick-buy");
          setTimeout(
            () => quickBuyContainer.classList.remove("is-animate-quick-buy"),
            1400
          );
        },
        { threshold: 0.8 }
      );
      this.firstSlideObserver.observe(firstSlide);
    }
    bindMouseFollow() {
      this.prevContainer?.addEventListener("mousemove", this.onPrevMouseMove);
      this.prevContainer?.addEventListener("mouseleave", this.onPrevMouseLeave);
      this.nextContainer?.addEventListener("mousemove", this.onNextMouseMove);
      this.nextContainer?.addEventListener("mouseleave", this.onNextMouseLeave);
    }
    initEmbla() {
      if (!this.viewport || !this.container) return;
      this.embla = EmblaCarousel(
        this.viewport,
        {
          dragFree: false,
          active: true,
          slidesToScroll: this.sliderToScrollMobile,
          "(min-width: 1024px)": {
            active: false,
            dragFree: true,
            slidesToScroll: this.sliderToScrollDesktop
          }
        },
        [EmblaCarouselAutoHeight()]
      );
      this.prevButton?.addEventListener("click", this.onPrevClick);
      this.nextButton?.addEventListener("click", this.onNextClick);
    }
    bindProgress() {
      if (!this.embla || !this.progressNode) return;
      const progressNode = this.progressNode;
      const applyProgress = () => {
        if (!this.embla) return;
        const snapCount = this.embla.scrollSnapList().length;
        const selected = this.embla.selectedScrollSnap();
        progressNode.style.width = `${100 / snapCount}%`;
        progressNode.style.transform = `translate3d(${selected * 100}%,0px,0px)`;
        this.prevButton?.parentElement?.toggleAttribute(
          "data-disabled",
          !this.embla.canScrollPrev()
        );
        this.nextButton?.parentElement?.toggleAttribute(
          "data-disabled",
          !this.embla.canScrollNext()
        );
        this.onScroll();
      };
      applyProgress();
      this.embla.on("reinit", () => applyProgress()).on("resize", () => applyProgress()).on("scroll", () => applyProgress()).on("slidefocus", () => applyProgress());
    }
    disconnectedCallback() {
      this.zoneAlignObserver?.disconnect();
      this.zoneAlignObserver = null;
      this.lastAlignedWidth = 0;
      this.embla?.destroy();
      this.embla = null;
      this.firstSlideObserver?.disconnect();
      this.firstSlideObserver = null;
      this.prevButton?.removeEventListener("click", this.onPrevClick);
      this.nextButton?.removeEventListener("click", this.onNextClick);
      this.prevContainer?.removeEventListener("mousemove", this.onPrevMouseMove);
      this.prevContainer?.removeEventListener("mouseleave", this.onPrevMouseLeave);
      this.nextContainer?.removeEventListener("mousemove", this.onNextMouseMove);
      this.nextContainer?.removeEventListener("mouseleave", this.onNextMouseLeave);
    }
  };

  // src/blocks/_collection-card-list/_collection-card-list.ts
  var GalleryList = class extends GalleryListBase {
  };
  if (!window.customElements.get("c-gallery-list")) {
    window.customElements.define("c-gallery-list", GalleryList);
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_collection-card"] && !Shopify.designMode) return;
  try {
    // ⚠ Auto-generated from src/blocks/_collection-card/_collection-card.ts — do not edit directly.
// src/blocks/_collection-card/_collection-card.ts
"use strict";
(() => {
  // src/blocks/_collection-card/_collection-card.ts
  var CollectionCard = class extends HTMLElement {
    connectedCallback() {
    }
    disconnectedCallback() {
    }
  };
  if (!window.customElements.get("c-collection-card")) {
    window.customElements.define("c-collection-card", CollectionCard);
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_counter-card"] && !Shopify.designMode) return;
  try {
    // ⚠ Auto-generated from src/blocks/_counter-card/_counter-card.ts — do not edit directly.
  // src/blocks/_counter-card/_counter-card.ts
  'use strict'
  ;(() => {
    var CounterCard = class extends HTMLElement {
      connectedCallback() {}
      disconnectedCallback() {}
    }
    window.customElements.get('c-counter-card') || window.customElements.define('c-counter-card', CounterCard)
  })()
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_form"] && !Shopify.designMode) return;
  try {
    // ⚠ Auto-generated from src/blocks/_form/_form.ts — do not edit directly.
// src/blocks/_form/_form.ts
"use strict";
(() => {
  // src/blocks/_form/_form.ts
  var FormNewsletter = class extends HTMLElement {
    constructor() {
      super();
      this.emailInput = null;
      this.checkboxInput = null;
      this.messageError = null;
      this.messageErrorCgv = null;
      this.submitButton = null;
      this._boundValidateEmail = this._validateEmail.bind(this);
      this._boundClearCgv = this._clearCgv.bind(this);
      this._boundUpdateButton = this._updateButton.bind(this);
      this._boundPreventInvalid = this._preventInvalid.bind(this);
    }
    connectedCallback() {
      this.emailInput = this.querySelector('input[type="email"]');
      this.checkboxInput = this.querySelector('input[type="checkbox"]');
      this.messageError = this.querySelector(".message--error [data-error-text]");
      this.messageErrorCgv = this.querySelector(
        ".message--error-cgv [data-error-text]"
      );
      this.submitButton = this.querySelector('[type="submit"]');
      this.emailInput?.addEventListener("input", this._boundValidateEmail);
      this.emailInput?.addEventListener("blur", this._boundValidateEmail);
      this.emailInput?.addEventListener("input", this._boundUpdateButton);
      this.checkboxInput?.addEventListener("change", this._boundClearCgv);
      this.checkboxInput?.addEventListener("change", this._boundUpdateButton);
      this.submitButton?.addEventListener("click", this._boundPreventInvalid);
      this._updateButton();
      this._focusSuccessMessage();
    }
    /**
     * After a full-page POST reload, live regions often skip content already in
     * the DOM. Focusing the success status moves the screen reader to it.
     */
    _focusSuccessMessage() {
      const successMessage = this.querySelector(".message--sucess");
      if (!successMessage) return;
      successMessage.setAttribute("tabindex", "-1");
      successMessage.focus();
    }
    disconnectedCallback() {
      this.emailInput?.removeEventListener("input", this._boundValidateEmail);
      this.emailInput?.removeEventListener("blur", this._boundValidateEmail);
      this.emailInput?.removeEventListener("input", this._boundUpdateButton);
      this.checkboxInput?.removeEventListener("change", this._boundClearCgv);
      this.checkboxInput?.removeEventListener("change", this._boundUpdateButton);
      this.submitButton?.removeEventListener("click", this._boundPreventInvalid);
    }
    _isValidEmail(email) {
      return /^([a-zA-Z0-9_\-.]+)@([a-zA-Z0-9_\-.]+)\.([a-zA-Z]{2,5})$/.test(
        email
      );
    }
    _validateEmail() {
      if (!this.emailInput || !this.messageError) return false;
      const email = this.emailInput.value.trim();
      let errorMessage = "";
      if (email.length === 0) {
        errorMessage = this.dataset.errorEmailEmpty ?? "";
      } else if (!this._isValidEmail(email)) {
        errorMessage = this.dataset.errorEmail ?? "";
      }
      const isInvalid = errorMessage.length > 0;
      this.classList.toggle("v-email-invalid", isInvalid);
      this.emailInput.setAttribute("aria-invalid", String(isInvalid));
      this.messageError.textContent = errorMessage;
      return isInvalid;
    }
    _validateCheckbox() {
      if (!this.checkboxInput || !this.messageErrorCgv) return false;
      const isInvalid = !this.checkboxInput.checked;
      this.classList.toggle("v-cgv-invalid", isInvalid);
      this.messageErrorCgv.textContent = isInvalid ? this.dataset.errorCgv ?? "" : "";
      return isInvalid;
    }
    _updateButton() {
      if (!this.submitButton) return;
      const email = this.emailInput?.value.trim() ?? "";
      const emailOk = email.length > 0 && this._isValidEmail(email);
      const cgvOk = this.checkboxInput ? this.checkboxInput.checked : true;
      this.submitButton.classList.toggle("is-form-disabled", !(emailOk && cgvOk));
    }
    _clearCgv() {
      this.classList.remove("v-cgv-invalid");
      if (this.messageErrorCgv) this.messageErrorCgv.textContent = "";
    }
    _preventInvalid(e) {
      const emailInvalid = this._validateEmail();
      const cgvInvalid = this._validateCheckbox();
      if (emailInvalid || cgvInvalid) {
        e.preventDefault();
        if (emailInvalid) this.emailInput?.focus();
      }
    }
  };
  if (!window.customElements.get("c-form-newsletter")) {
    window.customElements.define("c-form-newsletter", FormNewsletter);
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_gallery-container"] && !Shopify.designMode) return;
  try {
    // ⚠ Auto-generated from src/blocks/_gallery-container/_gallery-container.ts — do not edit directly.
// src/blocks/_gallery-container/_gallery-container.ts
"use strict";
(() => {
  // src/blocks/_gallery-container/_gallery-container.ts
  var GalleryContainer = class extends HTMLElement {
    constructor() {
      super();
      this.titleObserver = null;
      this.containerTabs = this.querySelector(".tabs");
      this.tabs = Array.from(this.querySelectorAll(".tabs button"));
      this.sliderLists = Array.from(this.querySelectorAll(".gallery-list"));
      this.tabsIsActive = this.dataset.tabsIsActive || null;
    }
    injectTitle(sliderList) {
      const injectTitle = sliderList.dataset.title;
      if (!injectTitle) return;
      const tab = this.tabs.find(
        (tab2) => tab2.dataset.id === sliderList.dataset.id
      );
      if (!tab) return;
      const label = tab.querySelector(".cta--label__text");
      if (!label) return;
      label.textContent = injectTitle;
    }
    connectedCallback() {
      this.sliderLists.forEach((sliderList, index) => {
        if (index !== 0) sliderList.classList.remove("is-active");
        this.injectTitle(sliderList);
      });
      this.titleObserver = new MutationObserver((mutations) => {
        mutations.forEach(
          (mutation) => this.injectTitle(mutation.target)
        );
      });
      this.sliderLists.forEach((sliderList) => {
        this.titleObserver?.observe(sliderList, {
          attributes: true,
          attributeFilter: ["data-title"]
        });
      });
      this.tabs.forEach((tab) => {
        tab.classList.remove("shimmer");
      });
      this.sliderLists.forEach((sliderList) => {
        sliderList.classList.remove("shimmer");
      });
      if (!this.tabsIsActive) return;
      this.tabs.forEach((tab) => {
        tab.addEventListener("click", this.handleTabClick.bind(this));
      });
    }
    handleTabClick(event) {
      const id = event.currentTarget.dataset.id;
      if (!id) return;
      this.toggleTab(id);
      this.toggleGridList(id);
    }
    toggleTab(id) {
      const currentTab = this.tabs.find((tab) => tab.dataset.id === id);
      if (!currentTab) return;
      this.tabs.forEach((tab) => {
        tab.classList.remove("is-active");
      });
      currentTab.classList.add("is-active");
    }
    toggleGridList(id) {
      const currentSliderList = this.sliderLists.find(
        (sliderList) => sliderList.classList.contains("is-active")
      );
      if (!currentSliderList) return;
      const nextSliderList = this.sliderLists.find(
        (sliderList) => sliderList.dataset.id === id
      );
      if (!nextSliderList) return;
      currentSliderList.classList.remove("is-active");
      nextSliderList.classList.add("is-active");
    }
    disconnectedCallback() {
      this.titleObserver?.disconnect();
      this.titleObserver = null;
      this.tabs.forEach((tab) => {
        tab.removeEventListener("click", this.handleTabClick.bind(this));
      });
    }
  };
  if (!window.customElements.get("c-gallery-container")) {
    window.customElements.define("c-gallery-container", GalleryContainer);
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_info-card-list"] && !Shopify.designMode) return;
  try {
    // ⚠ Auto-generated from src/blocks/_info-card-list/_info-card-list.ts — do not edit directly.
// src/blocks/_info-card-list/_info-card-list.ts
"use strict";
(() => {
  // src/shared/card-product/align-product-card-zones.ts
  var CARD_SELECTOR = ".card-product:not(.set-to-compose)";
  var ZONE_CONFIGS = [
    { selector: ".card-product__meta", cssVar: "--card-meta-min-height" },
    { selector: ".card-product__price", cssVar: "--card-price-min-height" }
  ];
  function groupIndicesByRow(tops) {
    const rows = [];
    for (const [index, top] of tops.entries()) {
      const row = rows.find((group) => {
        const first = group[0];
        return first !== void 0 && Math.abs((tops[first] ?? 0) - top) <= 1;
      });
      if (row) {
        row.push(index);
      } else {
        rows.push([index]);
      }
    }
    return rows;
  }
  function alignProductCardZones(root) {
    const cards = Array.from(root.querySelectorAll(CARD_SELECTOR));
    if (cards.length === 0) return;
    const zones = ZONE_CONFIGS.map(
      ({ selector }) => cards.map((card) => card.querySelector(selector))
    );
    for (const [zoneIndex, elements] of zones.entries()) {
      const cssVar = ZONE_CONFIGS[zoneIndex]?.cssVar;
      if (cssVar === void 0) continue;
      for (const el of elements) {
        el?.style.setProperty(cssVar, "0px");
      }
    }
    const tops = cards.map((card) => card.offsetTop);
    const heights = zones.map(
      (elements) => elements.map((el) => el?.scrollHeight ?? 0)
    );
    const rows = groupIndicesByRow(tops);
    for (const [zoneIndex, elements] of zones.entries()) {
      const cssVar = ZONE_CONFIGS[zoneIndex]?.cssVar;
      const zoneHeights = heights[zoneIndex];
      if (cssVar === void 0 || zoneHeights === void 0) continue;
      for (const row of rows) {
        let maxHeight = 0;
        for (const index of row) {
          maxHeight = Math.max(maxHeight, zoneHeights[index] ?? 0);
        }
        const value = `${String(maxHeight)}px`;
        for (const index of row) {
          elements[index]?.style.setProperty(cssVar, value);
        }
      }
    }
  }

  // src/shared/card-product/predecode-hover-visuals.ts
  var HOVER_IMAGE_SELECTOR = ".card-product_image.is-hover-active figure:nth-child(even) img";
  var NEAR_VIEWPORT_MARGIN = "400px";
  var seen = /* @__PURE__ */ new WeakSet();
  var observer = null;
  function whenIdle(task) {
    if (typeof requestIdleCallback === "function") {
      requestIdleCallback(task, { timeout: 2e3 });
      return;
    }
    window.setTimeout(task, 200);
  }
  function decodeWhenLoaded(image) {
    const decode = () => whenIdle(() => void image.decode().catch(() => {
    }));
    if (image.complete && image.naturalWidth > 0) {
      decode();
      return;
    }
    image.addEventListener("load", decode, { once: true });
  }
  function nearViewportObserver() {
    if (observer) return observer;
    if (typeof IntersectionObserver !== "function") return null;
    observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          observer?.unobserve(entry.target);
          decodeWhenLoaded(entry.target);
        }
      },
      { rootMargin: NEAR_VIEWPORT_MARGIN }
    );
    return observer;
  }
  function predecodeHoverVisuals(root) {
    const images = root.querySelectorAll(HOVER_IMAGE_SELECTOR);
    if (images.length === 0) return;
    const io = nearViewportObserver();
    for (const image of images) {
      if (seen.has(image)) continue;
      seen.add(image);
      if (!io) {
        decodeWhenLoaded(image);
        continue;
      }
      io.observe(image);
    }
  }

  // src/shared/gallery_list/gallery_list.ts
  var GalleryListBase = class extends HTMLElement {
    constructor() {
      super(...arguments);
      this.embla = null;
      this.sliderToScrollMobile = "auto";
      this.sliderToScrollDesktop = "auto";
      this.parentContainer = null;
      this.viewport = null;
      this.container = null;
      this.prevButton = null;
      this.nextButton = null;
      this.progressNode = null;
      this.prevContainer = null;
      this.nextContainer = null;
      this.firstSlideObserver = null;
      this.zoneAlignObserver = null;
      this.isAligningZones = false;
      /** Dernière largeur alignée, pour ignorer les resizes en hauteur. */
      this.lastAlignedWidth = 0;
      this.onPrevClick = () => this.embla?.scrollPrev();
      this.onNextClick = () => this.embla?.scrollNext();
      this.onPrevMouseMove = (e) => this.followMouse(e, this.prevButton);
      this.onNextMouseMove = (e) => this.followMouse(e, this.nextButton);
      this.onPrevMouseLeave = () => this.resetButton(this.prevButton);
      this.onNextMouseLeave = () => this.resetButton(this.nextButton);
      /**
       * Re-equalizes card text zones; skips while a sync is already in flight.
       *
       * Ne touche PAS au `ResizeObserver` : le déconnecter ici puis le ré-`observe()`
       * en sortie relançait l'alignement à chaque frame, sans fin — `observe()` remet
       * `lastReportedSize` à zéro, donc la notification suivante était garantie. Voir
       * la garde en largeur de `bindZoneAlignment`.
       */
      this.alignZones = () => {
        if (!this.container || this.isAligningZones) return;
        this.isAligningZones = true;
        try {
          alignProductCardZones(this.container);
          predecodeHoverVisuals(this.container);
        } finally {
          this.isAligningZones = false;
        }
      };
    }
    followMouse(e, button) {
      if (!button) return;
      const container = e.currentTarget;
      const rect = container.getBoundingClientRect();
      const offsetX = e.clientX - rect.left - rect.width / 2;
      const offsetY = e.clientY - rect.top - rect.height / 2;
      button.style.transform = `translate(${offsetX}px, ${offsetY}px)`;
    }
    resetButton(button) {
      if (!button) return;
      button.style.transform = "";
    }
    // Hook for subclasses to react to scroll events
    onScroll() {
    }
    connectedCallback() {
      this.parentContainer = this.closest("c-gallery-container");
      this.viewport = this.querySelector(".embla__viewport");
      this.container = this.querySelector(".embla__container");
      this.prevButton = this.querySelector(".embla__prev");
      this.nextButton = this.querySelector(".embla__next");
      this.progressNode = this.querySelector(".embla__progress__bar");
      this.prevContainer = this.querySelector(".container_embla__prev");
      this.nextContainer = this.querySelector(".container_embla__next");
      this.sliderToScrollMobile = this.dataset.slidesToScrollMobile || "auto";
      this.sliderToScrollDesktop = this.dataset.slidesToScrollDesktop || "auto";
      if (this.parentContainer?.classList.contains("v-slider")) {
        this.initEmbla();
        this.bindProgress();
        this.bindMouseFollow();
      }
      this.classList.remove("shimmer");
      this.bindFirstSlideAnimation();
      this.bindZoneAlignment();
    }
    /**
     * Keeps meta / price aligned across cards in a row.
     * Runs on connect, Embla reinit/resize, and container width changes. Does not
     * call embla.reInit() to avoid AutoHeight loops.
     *
     * Garde en LARGEUR : l'alignement ne dépend que de la largeur disponible et ne
     * produit que des changements de HAUTEUR. Réagir à la hauteur revenait à
     * réagir à son propre effet. Le chargement des polices, que l'observation
     * rattrapait par accident, est accroché explicitement plus bas.
     */
    bindZoneAlignment() {
      const container = this.container;
      if (!container) return;
      this.alignZones();
      this.zoneAlignObserver = new ResizeObserver((entries) => {
        const width = Math.round(entries[0]?.contentRect.width ?? 0);
        if (width === 0 || width === this.lastAlignedWidth) return;
        this.lastAlignedWidth = width;
        this.alignZones();
      });
      this.lastAlignedWidth = Math.round(container.getBoundingClientRect().width);
      this.zoneAlignObserver.observe(container);
      void document.fonts.ready.then(() => this.alignZones());
      this.embla?.on("reinit", () => this.alignZones()).on("resize", () => this.alignZones());
    }
    bindFirstSlideAnimation() {
      const firstSlide = this.querySelector(
        ".embla__slide:first-child"
      );
      if (!firstSlide) return;
      this.firstSlideObserver = new IntersectionObserver(
        (entries) => {
          const entry = entries[0];
          if (!entry.isIntersecting) return;
          this.firstSlideObserver?.disconnect();
          this.firstSlideObserver = null;
          const quickBuyContainer = firstSlide.querySelector(
            ".card-product-quick-buy__container"
          );
          if (!quickBuyContainer) return;
          quickBuyContainer.classList.add("is-animate-quick-buy");
          setTimeout(
            () => quickBuyContainer.classList.remove("is-animate-quick-buy"),
            1400
          );
        },
        { threshold: 0.8 }
      );
      this.firstSlideObserver.observe(firstSlide);
    }
    bindMouseFollow() {
      this.prevContainer?.addEventListener("mousemove", this.onPrevMouseMove);
      this.prevContainer?.addEventListener("mouseleave", this.onPrevMouseLeave);
      this.nextContainer?.addEventListener("mousemove", this.onNextMouseMove);
      this.nextContainer?.addEventListener("mouseleave", this.onNextMouseLeave);
    }
    initEmbla() {
      if (!this.viewport || !this.container) return;
      this.embla = EmblaCarousel(
        this.viewport,
        {
          dragFree: false,
          active: true,
          slidesToScroll: this.sliderToScrollMobile,
          "(min-width: 1024px)": {
            active: false,
            dragFree: true,
            slidesToScroll: this.sliderToScrollDesktop
          }
        },
        [EmblaCarouselAutoHeight()]
      );
      this.prevButton?.addEventListener("click", this.onPrevClick);
      this.nextButton?.addEventListener("click", this.onNextClick);
    }
    bindProgress() {
      if (!this.embla || !this.progressNode) return;
      const progressNode = this.progressNode;
      const applyProgress = () => {
        if (!this.embla) return;
        const snapCount = this.embla.scrollSnapList().length;
        const selected = this.embla.selectedScrollSnap();
        progressNode.style.width = `${100 / snapCount}%`;
        progressNode.style.transform = `translate3d(${selected * 100}%,0px,0px)`;
        this.prevButton?.parentElement?.toggleAttribute(
          "data-disabled",
          !this.embla.canScrollPrev()
        );
        this.nextButton?.parentElement?.toggleAttribute(
          "data-disabled",
          !this.embla.canScrollNext()
        );
        this.onScroll();
      };
      applyProgress();
      this.embla.on("reinit", () => applyProgress()).on("resize", () => applyProgress()).on("scroll", () => applyProgress()).on("slidefocus", () => applyProgress());
    }
    disconnectedCallback() {
      this.zoneAlignObserver?.disconnect();
      this.zoneAlignObserver = null;
      this.lastAlignedWidth = 0;
      this.embla?.destroy();
      this.embla = null;
      this.firstSlideObserver?.disconnect();
      this.firstSlideObserver = null;
      this.prevButton?.removeEventListener("click", this.onPrevClick);
      this.nextButton?.removeEventListener("click", this.onNextClick);
      this.prevContainer?.removeEventListener("mousemove", this.onPrevMouseMove);
      this.prevContainer?.removeEventListener("mouseleave", this.onPrevMouseLeave);
      this.nextContainer?.removeEventListener("mousemove", this.onNextMouseMove);
      this.nextContainer?.removeEventListener("mouseleave", this.onNextMouseLeave);
    }
  };

  // src/blocks/_info-card-list/_info-card-list.ts
  var GalleryList = class extends GalleryListBase {
  };
  if (!window.customElements.get("c-gallery-list")) {
    window.customElements.define("c-gallery-list", GalleryList);
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_info-card"] && !Shopify.designMode) return;
  try {
    // ⚠ Auto-generated from src/blocks/_info-card/_info-card.ts — do not edit directly.
// src/blocks/_info-card/_info-card.ts
"use strict";
(() => {
  // src/blocks/_info-card/_info-card.ts
  var InfoCard = class extends HTMLElement {
    connectedCallback() {
    }
    disconnectedCallback() {
    }
  };
  if (!window.customElements.get("c-info-card")) {
    window.customElements.define("c-info-card", InfoCard);
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_link_calendar"] && !Shopify.designMode) return;
  try {
    // ⚠ Auto-generated from src/blocks/_link_calendar/_link_calendar.ts — do not edit directly.
// src/blocks/_link_calendar/_link_calendar.ts
"use strict";
(() => {
  // src/shared/calendar/calendar-button.ts
  var PRODID = "-//Diptyque//Calendar Event//FR";
  var UID_DOMAIN = "diptyqueparis.com";
  var FOLD_LIMIT = 75;
  var encoder = new TextEncoder();
  function escapeText(value) {
    return value.replace(/\\/g, "\\\\").replace(/[;,]/g, "\\$&").replace(/\r\n|\r|\n/g, "\\n");
  }
  function foldLine(line) {
    if (encoder.encode(line).length <= FOLD_LIMIT) return line;
    const parts = [];
    let chunk = "";
    let bytes = 0;
    let limit = FOLD_LIMIT;
    for (const char of line) {
      const size = encoder.encode(char).length;
      if (bytes + size > limit) {
        parts.push(chunk);
        chunk = "";
        bytes = 0;
        limit = FOLD_LIMIT - 1;
      }
      chunk += char;
      bytes += size;
    }
    parts.push(chunk);
    return parts.join("\r\n ");
  }
  function toUtcStamp(epochSeconds) {
    return new Date(epochSeconds * 1e3).toISOString().replace(/[-:]/g, "").replace(/\.\d+Z$/, "Z");
  }
  function slugify(value) {
    return value.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-zA-Z0-9]+/g, "-").replace(/^-+|-+$/g, "").toLowerCase();
  }
  var CalendarButton = class extends HTMLElement {
    constructor() {
      super(...arguments);
      this.handleClick = (event) => {
        const target = event.target;
        if (!target?.closest("button")) return;
        this.download();
      };
    }
    connectedCallback() {
      this.addEventListener("click", this.handleClick);
    }
    /** Attributes are read here, never cached: the editor rewrites them in place. */
    timestamp(raw) {
      if (!raw) return null;
      const value = Number(raw);
      return Number.isFinite(value) ? value : null;
    }
    download() {
      const start = this.timestamp(this.dataset.startTs);
      const end = this.timestamp(this.dataset.endTs);
      if (start === null || end === null) {
        console.error(
          "c-calendar-button: data-start-ts / data-end-ts must be epoch seconds"
        );
        return;
      }
      const title = this.dataset.title || "";
      const slug = slugify(title) || "evenement";
      const startStamp = toUtcStamp(start);
      const lines = [
        "BEGIN:VCALENDAR",
        "VERSION:2.0",
        `PRODID:${PRODID}`,
        "CALSCALE:GREGORIAN",
        "METHOD:PUBLISH",
        "BEGIN:VEVENT",
        // Deterministic: re-downloading updates the event instead of duplicating it.
        `UID:${startStamp}-${slug}@${UID_DOMAIN}`,
        `DTSTAMP:${toUtcStamp(Date.now() / 1e3)}`,
        `DTSTART:${startStamp}`,
        `DTEND:${toUtcStamp(end)}`,
        `SUMMARY:${escapeText(title)}`,
        `DESCRIPTION:${escapeText(this.dataset.description || "")}`,
        `LOCATION:${escapeText(this.dataset.location || "")}`,
        "STATUS:CONFIRMED",
        "SEQUENCE:0",
        "BEGIN:VALARM",
        "TRIGGER:-PT15M",
        "ACTION:DISPLAY",
        "DESCRIPTION:Reminder",
        "END:VALARM",
        "END:VEVENT",
        "END:VCALENDAR"
      ];
      const blob = new Blob([lines.map(foldLine).join("\r\n")], {
        type: "text/calendar;charset=utf-8"
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${slug}.ics`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    }
  };
  function defineCalendarButton() {
    if (!window.customElements.get("c-calendar-button")) {
      window.customElements.define("c-calendar-button", CalendarButton);
    }
  }

  // src/blocks/_link_calendar/_link_calendar.ts
  defineCalendarButton();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_media-card"] && !Shopify.designMode) return;
  try {
    // ⚠ Auto-generated from src/blocks/_media-card/_media-card.ts — do not edit directly.
// src/blocks/_media-card/_media-card.ts
"use strict";
(() => {
  // src/blocks/_media-card/_media-card.ts
  var MediaCard = class extends HTMLElement {
    connectedCallback() {
    }
    disconnectedCallback() {
    }
  };
  if (!window.customElements.get("c-media-card")) {
    window.customElements.define("c-media-card", MediaCard);
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_media-card_list"] && !Shopify.designMode) return;
  try {
    // ⚠ Auto-generated from src/blocks/_media-card_list/_media-card_list.ts — do not edit directly.
// src/blocks/_media-card_list/_media-card_list.ts
"use strict";
(() => {
  // src/shared/card-product/align-product-card-zones.ts
  var CARD_SELECTOR = ".card-product:not(.set-to-compose)";
  var ZONE_CONFIGS = [
    { selector: ".card-product__meta", cssVar: "--card-meta-min-height" },
    { selector: ".card-product__price", cssVar: "--card-price-min-height" }
  ];
  function groupIndicesByRow(tops) {
    const rows = [];
    for (const [index, top] of tops.entries()) {
      const row = rows.find((group) => {
        const first = group[0];
        return first !== void 0 && Math.abs((tops[first] ?? 0) - top) <= 1;
      });
      if (row) {
        row.push(index);
      } else {
        rows.push([index]);
      }
    }
    return rows;
  }
  function alignProductCardZones(root) {
    const cards = Array.from(root.querySelectorAll(CARD_SELECTOR));
    if (cards.length === 0) return;
    const zones = ZONE_CONFIGS.map(
      ({ selector }) => cards.map((card) => card.querySelector(selector))
    );
    for (const [zoneIndex, elements] of zones.entries()) {
      const cssVar = ZONE_CONFIGS[zoneIndex]?.cssVar;
      if (cssVar === void 0) continue;
      for (const el of elements) {
        el?.style.setProperty(cssVar, "0px");
      }
    }
    const tops = cards.map((card) => card.offsetTop);
    const heights = zones.map(
      (elements) => elements.map((el) => el?.scrollHeight ?? 0)
    );
    const rows = groupIndicesByRow(tops);
    for (const [zoneIndex, elements] of zones.entries()) {
      const cssVar = ZONE_CONFIGS[zoneIndex]?.cssVar;
      const zoneHeights = heights[zoneIndex];
      if (cssVar === void 0 || zoneHeights === void 0) continue;
      for (const row of rows) {
        let maxHeight = 0;
        for (const index of row) {
          maxHeight = Math.max(maxHeight, zoneHeights[index] ?? 0);
        }
        const value = `${String(maxHeight)}px`;
        for (const index of row) {
          elements[index]?.style.setProperty(cssVar, value);
        }
      }
    }
  }

  // src/shared/card-product/predecode-hover-visuals.ts
  var HOVER_IMAGE_SELECTOR = ".card-product_image.is-hover-active figure:nth-child(even) img";
  var NEAR_VIEWPORT_MARGIN = "400px";
  var seen = /* @__PURE__ */ new WeakSet();
  var observer = null;
  function whenIdle(task) {
    if (typeof requestIdleCallback === "function") {
      requestIdleCallback(task, { timeout: 2e3 });
      return;
    }
    window.setTimeout(task, 200);
  }
  function decodeWhenLoaded(image) {
    const decode = () => whenIdle(() => void image.decode().catch(() => {
    }));
    if (image.complete && image.naturalWidth > 0) {
      decode();
      return;
    }
    image.addEventListener("load", decode, { once: true });
  }
  function nearViewportObserver() {
    if (observer) return observer;
    if (typeof IntersectionObserver !== "function") return null;
    observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          observer?.unobserve(entry.target);
          decodeWhenLoaded(entry.target);
        }
      },
      { rootMargin: NEAR_VIEWPORT_MARGIN }
    );
    return observer;
  }
  function predecodeHoverVisuals(root) {
    const images = root.querySelectorAll(HOVER_IMAGE_SELECTOR);
    if (images.length === 0) return;
    const io = nearViewportObserver();
    for (const image of images) {
      if (seen.has(image)) continue;
      seen.add(image);
      if (!io) {
        decodeWhenLoaded(image);
        continue;
      }
      io.observe(image);
    }
  }

  // src/shared/gallery_list/gallery_list.ts
  var GalleryListBase = class extends HTMLElement {
    constructor() {
      super(...arguments);
      this.embla = null;
      this.sliderToScrollMobile = "auto";
      this.sliderToScrollDesktop = "auto";
      this.parentContainer = null;
      this.viewport = null;
      this.container = null;
      this.prevButton = null;
      this.nextButton = null;
      this.progressNode = null;
      this.prevContainer = null;
      this.nextContainer = null;
      this.firstSlideObserver = null;
      this.zoneAlignObserver = null;
      this.isAligningZones = false;
      /** Dernière largeur alignée, pour ignorer les resizes en hauteur. */
      this.lastAlignedWidth = 0;
      this.onPrevClick = () => this.embla?.scrollPrev();
      this.onNextClick = () => this.embla?.scrollNext();
      this.onPrevMouseMove = (e) => this.followMouse(e, this.prevButton);
      this.onNextMouseMove = (e) => this.followMouse(e, this.nextButton);
      this.onPrevMouseLeave = () => this.resetButton(this.prevButton);
      this.onNextMouseLeave = () => this.resetButton(this.nextButton);
      /**
       * Re-equalizes card text zones; skips while a sync is already in flight.
       *
       * Ne touche PAS au `ResizeObserver` : le déconnecter ici puis le ré-`observe()`
       * en sortie relançait l'alignement à chaque frame, sans fin — `observe()` remet
       * `lastReportedSize` à zéro, donc la notification suivante était garantie. Voir
       * la garde en largeur de `bindZoneAlignment`.
       */
      this.alignZones = () => {
        if (!this.container || this.isAligningZones) return;
        this.isAligningZones = true;
        try {
          alignProductCardZones(this.container);
          predecodeHoverVisuals(this.container);
        } finally {
          this.isAligningZones = false;
        }
      };
    }
    followMouse(e, button) {
      if (!button) return;
      const container = e.currentTarget;
      const rect = container.getBoundingClientRect();
      const offsetX = e.clientX - rect.left - rect.width / 2;
      const offsetY = e.clientY - rect.top - rect.height / 2;
      button.style.transform = `translate(${offsetX}px, ${offsetY}px)`;
    }
    resetButton(button) {
      if (!button) return;
      button.style.transform = "";
    }
    // Hook for subclasses to react to scroll events
    onScroll() {
    }
    connectedCallback() {
      this.parentContainer = this.closest("c-gallery-container");
      this.viewport = this.querySelector(".embla__viewport");
      this.container = this.querySelector(".embla__container");
      this.prevButton = this.querySelector(".embla__prev");
      this.nextButton = this.querySelector(".embla__next");
      this.progressNode = this.querySelector(".embla__progress__bar");
      this.prevContainer = this.querySelector(".container_embla__prev");
      this.nextContainer = this.querySelector(".container_embla__next");
      this.sliderToScrollMobile = this.dataset.slidesToScrollMobile || "auto";
      this.sliderToScrollDesktop = this.dataset.slidesToScrollDesktop || "auto";
      if (this.parentContainer?.classList.contains("v-slider")) {
        this.initEmbla();
        this.bindProgress();
        this.bindMouseFollow();
      }
      this.classList.remove("shimmer");
      this.bindFirstSlideAnimation();
      this.bindZoneAlignment();
    }
    /**
     * Keeps meta / price aligned across cards in a row.
     * Runs on connect, Embla reinit/resize, and container width changes. Does not
     * call embla.reInit() to avoid AutoHeight loops.
     *
     * Garde en LARGEUR : l'alignement ne dépend que de la largeur disponible et ne
     * produit que des changements de HAUTEUR. Réagir à la hauteur revenait à
     * réagir à son propre effet. Le chargement des polices, que l'observation
     * rattrapait par accident, est accroché explicitement plus bas.
     */
    bindZoneAlignment() {
      const container = this.container;
      if (!container) return;
      this.alignZones();
      this.zoneAlignObserver = new ResizeObserver((entries) => {
        const width = Math.round(entries[0]?.contentRect.width ?? 0);
        if (width === 0 || width === this.lastAlignedWidth) return;
        this.lastAlignedWidth = width;
        this.alignZones();
      });
      this.lastAlignedWidth = Math.round(container.getBoundingClientRect().width);
      this.zoneAlignObserver.observe(container);
      void document.fonts.ready.then(() => this.alignZones());
      this.embla?.on("reinit", () => this.alignZones()).on("resize", () => this.alignZones());
    }
    bindFirstSlideAnimation() {
      const firstSlide = this.querySelector(
        ".embla__slide:first-child"
      );
      if (!firstSlide) return;
      this.firstSlideObserver = new IntersectionObserver(
        (entries) => {
          const entry = entries[0];
          if (!entry.isIntersecting) return;
          this.firstSlideObserver?.disconnect();
          this.firstSlideObserver = null;
          const quickBuyContainer = firstSlide.querySelector(
            ".card-product-quick-buy__container"
          );
          if (!quickBuyContainer) return;
          quickBuyContainer.classList.add("is-animate-quick-buy");
          setTimeout(
            () => quickBuyContainer.classList.remove("is-animate-quick-buy"),
            1400
          );
        },
        { threshold: 0.8 }
      );
      this.firstSlideObserver.observe(firstSlide);
    }
    bindMouseFollow() {
      this.prevContainer?.addEventListener("mousemove", this.onPrevMouseMove);
      this.prevContainer?.addEventListener("mouseleave", this.onPrevMouseLeave);
      this.nextContainer?.addEventListener("mousemove", this.onNextMouseMove);
      this.nextContainer?.addEventListener("mouseleave", this.onNextMouseLeave);
    }
    initEmbla() {
      if (!this.viewport || !this.container) return;
      this.embla = EmblaCarousel(
        this.viewport,
        {
          dragFree: false,
          active: true,
          slidesToScroll: this.sliderToScrollMobile,
          "(min-width: 1024px)": {
            active: false,
            dragFree: true,
            slidesToScroll: this.sliderToScrollDesktop
          }
        },
        [EmblaCarouselAutoHeight()]
      );
      this.prevButton?.addEventListener("click", this.onPrevClick);
      this.nextButton?.addEventListener("click", this.onNextClick);
    }
    bindProgress() {
      if (!this.embla || !this.progressNode) return;
      const progressNode = this.progressNode;
      const applyProgress = () => {
        if (!this.embla) return;
        const snapCount = this.embla.scrollSnapList().length;
        const selected = this.embla.selectedScrollSnap();
        progressNode.style.width = `${100 / snapCount}%`;
        progressNode.style.transform = `translate3d(${selected * 100}%,0px,0px)`;
        this.prevButton?.parentElement?.toggleAttribute(
          "data-disabled",
          !this.embla.canScrollPrev()
        );
        this.nextButton?.parentElement?.toggleAttribute(
          "data-disabled",
          !this.embla.canScrollNext()
        );
        this.onScroll();
      };
      applyProgress();
      this.embla.on("reinit", () => applyProgress()).on("resize", () => applyProgress()).on("scroll", () => applyProgress()).on("slidefocus", () => applyProgress());
    }
    disconnectedCallback() {
      this.zoneAlignObserver?.disconnect();
      this.zoneAlignObserver = null;
      this.lastAlignedWidth = 0;
      this.embla?.destroy();
      this.embla = null;
      this.firstSlideObserver?.disconnect();
      this.firstSlideObserver = null;
      this.prevButton?.removeEventListener("click", this.onPrevClick);
      this.nextButton?.removeEventListener("click", this.onNextClick);
      this.prevContainer?.removeEventListener("mousemove", this.onPrevMouseMove);
      this.prevContainer?.removeEventListener("mouseleave", this.onPrevMouseLeave);
      this.nextContainer?.removeEventListener("mousemove", this.onNextMouseMove);
      this.nextContainer?.removeEventListener("mouseleave", this.onNextMouseLeave);
    }
  };

  // src/blocks/_media-card_list/_media-card_list.ts
  var GalleryList = class extends GalleryListBase {
  };
  if (!window.customElements.get("c-gallery-list")) {
    window.customElements.define("c-gallery-list", GalleryList);
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_media-container"] && !Shopify.designMode) return;
  try {
    // ⚠ Auto-generated from src/blocks/_media-container/_media-container.ts — do not edit directly.
// src/blocks/_media-container/_media-container.ts
"use strict";
(() => {
  // src/blocks/_media-container/_media-container.ts
  var MediaContainer = class extends HTMLElement {
    constructor() {
      super(...arguments);
      this.observer = null;
    }
    connectedCallback() {
      if (!this.hasAttribute("data-animate-card")) return;
      this.observer = new IntersectionObserver(
        (entries, obs) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.classList.add("is-visible");
              obs.unobserve(this);
            }
          });
        },
        { rootMargin: "0px", threshold: 0.1 }
      );
      this.observer.observe(this);
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.observer = null;
    }
  };
  if (!window.customElements.get("c-media-container")) {
    window.customElements.define("c-media-container", MediaContainer);
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-card-list"] && !Shopify.designMode) return;
  try {
    // ⚠ Auto-generated from src/blocks/_product-card-list/_product-card-list.ts — do not edit directly.
// src/blocks/_product-card-list/_product-card-list.ts
"use strict";
(() => {
  // src/shared/card-product/align-product-card-zones.ts
  var CARD_SELECTOR = ".card-product:not(.set-to-compose)";
  var ZONE_CONFIGS = [
    { selector: ".card-product__meta", cssVar: "--card-meta-min-height" },
    { selector: ".card-product__price", cssVar: "--card-price-min-height" }
  ];
  function groupIndicesByRow(tops) {
    const rows = [];
    for (const [index, top] of tops.entries()) {
      const row = rows.find((group) => {
        const first = group[0];
        return first !== void 0 && Math.abs((tops[first] ?? 0) - top) <= 1;
      });
      if (row) {
        row.push(index);
      } else {
        rows.push([index]);
      }
    }
    return rows;
  }
  function alignProductCardZones(root) {
    const cards = Array.from(root.querySelectorAll(CARD_SELECTOR));
    if (cards.length === 0) return;
    const zones = ZONE_CONFIGS.map(
      ({ selector }) => cards.map((card) => card.querySelector(selector))
    );
    for (const [zoneIndex, elements] of zones.entries()) {
      const cssVar = ZONE_CONFIGS[zoneIndex]?.cssVar;
      if (cssVar === void 0) continue;
      for (const el of elements) {
        el?.style.setProperty(cssVar, "0px");
      }
    }
    const tops = cards.map((card) => card.offsetTop);
    const heights = zones.map(
      (elements) => elements.map((el) => el?.scrollHeight ?? 0)
    );
    const rows = groupIndicesByRow(tops);
    for (const [zoneIndex, elements] of zones.entries()) {
      const cssVar = ZONE_CONFIGS[zoneIndex]?.cssVar;
      const zoneHeights = heights[zoneIndex];
      if (cssVar === void 0 || zoneHeights === void 0) continue;
      for (const row of rows) {
        let maxHeight = 0;
        for (const index of row) {
          maxHeight = Math.max(maxHeight, zoneHeights[index] ?? 0);
        }
        const value = `${String(maxHeight)}px`;
        for (const index of row) {
          elements[index]?.style.setProperty(cssVar, value);
        }
      }
    }
  }

  // src/shared/card-product/predecode-hover-visuals.ts
  var HOVER_IMAGE_SELECTOR = ".card-product_image.is-hover-active figure:nth-child(even) img";
  var NEAR_VIEWPORT_MARGIN = "400px";
  var seen = /* @__PURE__ */ new WeakSet();
  var observer = null;
  function whenIdle(task) {
    if (typeof requestIdleCallback === "function") {
      requestIdleCallback(task, { timeout: 2e3 });
      return;
    }
    window.setTimeout(task, 200);
  }
  function decodeWhenLoaded(image) {
    const decode = () => whenIdle(() => void image.decode().catch(() => {
    }));
    if (image.complete && image.naturalWidth > 0) {
      decode();
      return;
    }
    image.addEventListener("load", decode, { once: true });
  }
  function nearViewportObserver() {
    if (observer) return observer;
    if (typeof IntersectionObserver !== "function") return null;
    observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          observer?.unobserve(entry.target);
          decodeWhenLoaded(entry.target);
        }
      },
      { rootMargin: NEAR_VIEWPORT_MARGIN }
    );
    return observer;
  }
  function predecodeHoverVisuals(root) {
    const images = root.querySelectorAll(HOVER_IMAGE_SELECTOR);
    if (images.length === 0) return;
    const io = nearViewportObserver();
    for (const image of images) {
      if (seen.has(image)) continue;
      seen.add(image);
      if (!io) {
        decodeWhenLoaded(image);
        continue;
      }
      io.observe(image);
    }
  }

  // src/shared/gallery_list/gallery_list.ts
  var GalleryListBase = class extends HTMLElement {
    constructor() {
      super(...arguments);
      this.embla = null;
      this.sliderToScrollMobile = "auto";
      this.sliderToScrollDesktop = "auto";
      this.parentContainer = null;
      this.viewport = null;
      this.container = null;
      this.prevButton = null;
      this.nextButton = null;
      this.progressNode = null;
      this.prevContainer = null;
      this.nextContainer = null;
      this.firstSlideObserver = null;
      this.zoneAlignObserver = null;
      this.isAligningZones = false;
      /** Dernière largeur alignée, pour ignorer les resizes en hauteur. */
      this.lastAlignedWidth = 0;
      this.onPrevClick = () => this.embla?.scrollPrev();
      this.onNextClick = () => this.embla?.scrollNext();
      this.onPrevMouseMove = (e) => this.followMouse(e, this.prevButton);
      this.onNextMouseMove = (e) => this.followMouse(e, this.nextButton);
      this.onPrevMouseLeave = () => this.resetButton(this.prevButton);
      this.onNextMouseLeave = () => this.resetButton(this.nextButton);
      /**
       * Re-equalizes card text zones; skips while a sync is already in flight.
       *
       * Ne touche PAS au `ResizeObserver` : le déconnecter ici puis le ré-`observe()`
       * en sortie relançait l'alignement à chaque frame, sans fin — `observe()` remet
       * `lastReportedSize` à zéro, donc la notification suivante était garantie. Voir
       * la garde en largeur de `bindZoneAlignment`.
       */
      this.alignZones = () => {
        if (!this.container || this.isAligningZones) return;
        this.isAligningZones = true;
        try {
          alignProductCardZones(this.container);
          predecodeHoverVisuals(this.container);
        } finally {
          this.isAligningZones = false;
        }
      };
    }
    followMouse(e, button) {
      if (!button) return;
      const container = e.currentTarget;
      const rect = container.getBoundingClientRect();
      const offsetX = e.clientX - rect.left - rect.width / 2;
      const offsetY = e.clientY - rect.top - rect.height / 2;
      button.style.transform = `translate(${offsetX}px, ${offsetY}px)`;
    }
    resetButton(button) {
      if (!button) return;
      button.style.transform = "";
    }
    // Hook for subclasses to react to scroll events
    onScroll() {
    }
    connectedCallback() {
      this.parentContainer = this.closest("c-gallery-container");
      this.viewport = this.querySelector(".embla__viewport");
      this.container = this.querySelector(".embla__container");
      this.prevButton = this.querySelector(".embla__prev");
      this.nextButton = this.querySelector(".embla__next");
      this.progressNode = this.querySelector(".embla__progress__bar");
      this.prevContainer = this.querySelector(".container_embla__prev");
      this.nextContainer = this.querySelector(".container_embla__next");
      this.sliderToScrollMobile = this.dataset.slidesToScrollMobile || "auto";
      this.sliderToScrollDesktop = this.dataset.slidesToScrollDesktop || "auto";
      if (this.parentContainer?.classList.contains("v-slider")) {
        this.initEmbla();
        this.bindProgress();
        this.bindMouseFollow();
      }
      this.classList.remove("shimmer");
      this.bindFirstSlideAnimation();
      this.bindZoneAlignment();
    }
    /**
     * Keeps meta / price aligned across cards in a row.
     * Runs on connect, Embla reinit/resize, and container width changes. Does not
     * call embla.reInit() to avoid AutoHeight loops.
     *
     * Garde en LARGEUR : l'alignement ne dépend que de la largeur disponible et ne
     * produit que des changements de HAUTEUR. Réagir à la hauteur revenait à
     * réagir à son propre effet. Le chargement des polices, que l'observation
     * rattrapait par accident, est accroché explicitement plus bas.
     */
    bindZoneAlignment() {
      const container = this.container;
      if (!container) return;
      this.alignZones();
      this.zoneAlignObserver = new ResizeObserver((entries) => {
        const width = Math.round(entries[0]?.contentRect.width ?? 0);
        if (width === 0 || width === this.lastAlignedWidth) return;
        this.lastAlignedWidth = width;
        this.alignZones();
      });
      this.lastAlignedWidth = Math.round(container.getBoundingClientRect().width);
      this.zoneAlignObserver.observe(container);
      void document.fonts.ready.then(() => this.alignZones());
      this.embla?.on("reinit", () => this.alignZones()).on("resize", () => this.alignZones());
    }
    bindFirstSlideAnimation() {
      const firstSlide = this.querySelector(
        ".embla__slide:first-child"
      );
      if (!firstSlide) return;
      this.firstSlideObserver = new IntersectionObserver(
        (entries) => {
          const entry = entries[0];
          if (!entry.isIntersecting) return;
          this.firstSlideObserver?.disconnect();
          this.firstSlideObserver = null;
          const quickBuyContainer = firstSlide.querySelector(
            ".card-product-quick-buy__container"
          );
          if (!quickBuyContainer) return;
          quickBuyContainer.classList.add("is-animate-quick-buy");
          setTimeout(
            () => quickBuyContainer.classList.remove("is-animate-quick-buy"),
            1400
          );
        },
        { threshold: 0.8 }
      );
      this.firstSlideObserver.observe(firstSlide);
    }
    bindMouseFollow() {
      this.prevContainer?.addEventListener("mousemove", this.onPrevMouseMove);
      this.prevContainer?.addEventListener("mouseleave", this.onPrevMouseLeave);
      this.nextContainer?.addEventListener("mousemove", this.onNextMouseMove);
      this.nextContainer?.addEventListener("mouseleave", this.onNextMouseLeave);
    }
    initEmbla() {
      if (!this.viewport || !this.container) return;
      this.embla = EmblaCarousel(
        this.viewport,
        {
          dragFree: false,
          active: true,
          slidesToScroll: this.sliderToScrollMobile,
          "(min-width: 1024px)": {
            active: false,
            dragFree: true,
            slidesToScroll: this.sliderToScrollDesktop
          }
        },
        [EmblaCarouselAutoHeight()]
      );
      this.prevButton?.addEventListener("click", this.onPrevClick);
      this.nextButton?.addEventListener("click", this.onNextClick);
    }
    bindProgress() {
      if (!this.embla || !this.progressNode) return;
      const progressNode = this.progressNode;
      const applyProgress = () => {
        if (!this.embla) return;
        const snapCount = this.embla.scrollSnapList().length;
        const selected = this.embla.selectedScrollSnap();
        progressNode.style.width = `${100 / snapCount}%`;
        progressNode.style.transform = `translate3d(${selected * 100}%,0px,0px)`;
        this.prevButton?.parentElement?.toggleAttribute(
          "data-disabled",
          !this.embla.canScrollPrev()
        );
        this.nextButton?.parentElement?.toggleAttribute(
          "data-disabled",
          !this.embla.canScrollNext()
        );
        this.onScroll();
      };
      applyProgress();
      this.embla.on("reinit", () => applyProgress()).on("resize", () => applyProgress()).on("scroll", () => applyProgress()).on("slidefocus", () => applyProgress());
    }
    disconnectedCallback() {
      this.zoneAlignObserver?.disconnect();
      this.zoneAlignObserver = null;
      this.lastAlignedWidth = 0;
      this.embla?.destroy();
      this.embla = null;
      this.firstSlideObserver?.disconnect();
      this.firstSlideObserver = null;
      this.prevButton?.removeEventListener("click", this.onPrevClick);
      this.nextButton?.removeEventListener("click", this.onNextClick);
      this.prevContainer?.removeEventListener("mousemove", this.onPrevMouseMove);
      this.prevContainer?.removeEventListener("mouseleave", this.onPrevMouseLeave);
      this.nextContainer?.removeEventListener("mousemove", this.onNextMouseMove);
      this.nextContainer?.removeEventListener("mouseleave", this.onNextMouseLeave);
    }
  };

  // src/blocks/_product-card-list/_product-card-list.ts
  var GalleryList = class extends GalleryListBase {
  };
  if (!window.customElements.get("c-gallery-list")) {
    window.customElements.define("c-gallery-list", GalleryList);
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-card"] && !Shopify.designMode) return;
  try {
    // ⚠ Auto-generated from src/blocks/_product-card/_product-card.ts — do not edit directly.
// src/blocks/_product-card/_product-card.ts
"use strict";
(() => {
  // src/blocks/_product-card/_product-card.ts
  var ProductCard = class extends HTMLElement {
    connectedCallback() {
    }
    disconnectedCallback() {
    }
  };
  if (!window.customElements.get("c-product-card")) {
    window.customElements.define("c-product-card", ProductCard);
  }
})();
  } catch(e) { console.error(e); }
})();

})();
